
import { ElectricalAspectEntityDecorator } from './electrical-aspect.decorator';
import { ElectricalAspect } from './electrical-aspect.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class ElectricalAspectTypeInfoBase implements CrudTypeInfo<ElectricalAspect, number> {
  name = 'Electrical Aspect';
  entityDecorator = new ElectricalAspectEntityDecorator();
  
  createAuthorities = ['WRITE_ELECTRICAL_ASPECT'];
  editAuthorities = ['WRITE_ELECTRICAL_ASPECT'];
  deleteAuthorities = ['WRITE_ELECTRICAL_ASPECT'];
  viewAuthorities = ['READ_ELECTRICAL_ASPECT'];
  
  searchRouteBase = ['/electricalaspect/search'];
  createRouteBase = ['/electricalaspect/create'];
  editRouteBase = ['/electricalaspect/edit'];
  viewRouteBase = ['/electricalaspect/view'];
  
  description(item: ElectricalAspect): string {
    return '' +  item.aspectAssetId;
  }
}



